<template>
  <div>
    <v-card flat class="pa-3 v-cls-header" v-if="text.headerImage || text.headerVideo">
      <v-img v-if="text.headerImage" :src="text.headerImage"></v-img>
      <div v-html="text.headerVideo" v-if="text.headerVideo"></div>
    </v-card>
    <v-card class="pa-0" flat color="#EDEFF0">
      <v-card-text>
        <h1>
          {{ text.title }} <small>{{ text.identifier }}</small>
        </h1>
        <div v-html="text.content"></div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "PageText",
  props: {
    text: Object
  }
};
</script>

<style scoped></style>
